export default __webpack_public_path__ + "static/media/sidemenu_appointment.e427f403.svg";